import { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { OrderFormat, OutletListItem } from '@ancon/wildcat-types'
import { Moment } from 'moment'
import getOutletPickerTimesForDay from '@ancon/wildcat-utils/outlet/getOutletPickerTimesForDay'
import { PickerTime } from '@ancon/wildcat-utils/outlet/types'

/**
 * The times an order can be placed for at an outlet on one day, in the
 * current language. Empty until both the order format and the date are known.
 */
export default function useOutletPickerTimes(
  outlet: OutletListItem | null | undefined,
  orderFormat: OrderFormat | null | undefined,
  date: Moment | string | null | undefined,
): PickerTime[] {
  const { lang } = useTranslation()

  return useMemo(() => {
    if (outlet && orderFormat && date) {
      return getOutletPickerTimesForDay(outlet, orderFormat, date, lang)
    }

    return []
  }, [outlet, orderFormat, date, lang])
}
